import React from "react";
import FooterOfgaranawa from "./FooterOfgaranawa";
import TableScrolegaranawa from "./TableScrolegaranawa";

const TableAllprintgaranawa = () => {
  return (
    <body>
      <TableScrolegaranawa />
      <br />
      <br />
      <FooterOfgaranawa />
    </body>
  );
};

export default TableAllprintgaranawa;
